import { StorageService } from './../services/storage.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  constructor(private local:StorageService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let token   = this.local.getInSession('api_token');

    if (!token) {
      return next.handle(request);
    }

    let headers = request.clone({
                    headers: request.headers.set('Authorization', `Bearer ${token}`)
                  });

    return next.handle(headers);
  }
}
